import React from 'react';
import WarmthChart from './WarmthChart';

function ProblemSection() {
  return (
    <section className="block problem">
      <div className="wrap">
        <div className="sec-head">
          <h2>The Problem</h2>
          <div className="rule" />
        </div>
        <div className="split">
          <WarmthChart />
          <div className="copy">
            <h3>
              Opportunities rarely die instantly. They{' '}
              <span className="accent">go cold over time.</span>
            </h3>
            <p>
              Teams spend enormous effort generating meetings and building pipeline — but many valuable
              relationships fade simply because there isn&apos;t consistent, meaningful follow-up after the
              first conversation. Reps get busy. Priorities shift.
            </p>
            <p>
              Outreach becomes inconsistent. And over time, promising opportunities quietly disappear from
              the pipeline. Most companies rely on generic nurture campaigns, sporadic check-ins, manual
              reminders or no follow-up strategy at all. As a result, relationships that could have turned
              into future revenue are forgotten long before timing aligns.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProblemSection;
